import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AppointmentsFlowStateService} from '../service/appointments-flow-state.service';
import {FlowStep} from '../model/flow-step';

@Injectable({
  providedIn: 'root'
})
export class AppointmentsFlowGuard implements CanActivate {
  constructor(
    private router: Router,
    private flowState: AppointmentsFlowStateService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, _: RouterStateSnapshot): boolean {
    const requiredStep = route.data['requiredStep'] as FlowStep | undefined;
    if (!requiredStep) {
      return true;
    }

    if (this.flowState.hasReached(requiredStep)) {
      return true;
    }

    const redirect = this.flowState.getRedirectRoute(requiredStep);
    this.router.navigate([redirect]);
    return false;
  }
}
